import { MAIN_PORTAL_INSTANCE_ID } from "@productlane/lib/src/portal-instance"

/**
 * `null` is the main portal, which also owns every legacy item that carries no
 * portal ids at all.
 */
export function itemInPortal(
	portalInstanceIds: readonly string[] | string[] | null | undefined,
	portalId: string | null,
): boolean {
	const ids = portalInstanceIds ?? []
	if (portalId === null)
		return ids.length === 0 || ids.includes(MAIN_PORTAL_INSTANCE_ID)
	return ids.includes(portalId)
}
